import { useParams, Link } from "react-router-dom";
import { Product, products } from "../data/products";
import { useState, useEffect } from "react";
import RenderGallery from "components/ImageGallery";
import { brandConfig } from "../config/brandConfig";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import SEOMeta from "components/SEOMeta";
import { ProductSEO } from "components/ProductSEO";
import RelatedProducts from "components/RelatedProducts";

export default function ProductDetail() {
  const { setItems } = useBreadcrumb();
  const { slug } = useParams<{ slug: string }>();
  const product: Product | undefined = products.find((p) => p.slug === slug);
  const [imageSrc, setImageSrc] = useState<string>("");
  useEffect(() => {
    if (!product) return;
    const first = product?.images?.[0] ?? "";
    setImageSrc(first);
  }, [product]);

  useEffect(() => {
    if (!product) return;
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Produits", href: "/produits" },
      { label: product.name },
    ]);
  }, [product, setItems]);

  if (!product) {
    return (
      <div>
        Produit introuvable. <Link to="/produits">Retour aux produits</Link>
      </div>
    );
  }

  const {
    name,
    images,
    short,
    specs,
    description,
    ficheTechnique,
    prixPublicConseille,
  } = product;

  const productsRelatedTo = products.filter((p) => p.slug !== product.slug);

  return (
    <>
      <SEOMeta
        title={name}
        description={short}
        canonicalPath={`/produits/${slug}`}
      />

      <ProductSEO product={product} productsRelatedTo={productsRelatedTo} />
      <section className="grid">
        <div
          className="card"
          style={{ minHeight: 240 }}
          aria-label="Image du produit"
        >
          <div>
            <img className="main-picture" src={imageSrc} alt={name} />
          </div>

          <RenderGallery
            images={images}
            onSelect={setImageSrc}
            current={imageSrc}
          />
        </div>
        <div className="product-desc">
          <h1>{name}</h1>
          <p className="color-product-desc">{short}</p>
          {prixPublicConseille && (
            <div style={{ margin: "16px 0" }}>
              <p style={{ fontSize: 18, fontWeight: 700 }}>
                Prix public conseillé : {prixPublicConseille} € TTC
              </p>
              <p className="small" style={{ opacity: 0.7 }}>
                Prix indicatif. Le prix final est librement fixé par chaque
                armurier partenaire.
              </p>

              <Link to="/revendeurs" className="btn" style={{ marginTop: 12 }}>
                Trouver un revendeur
              </Link>

              {brandConfig.isResellerBrand && (
                <p className="small" style={{ marginTop: 8, opacity: 0.7 }}>
                  {brandConfig.salesChannelLabel}
                </p>
              )}
            </div>
          )}
          <hr />
          <h2>Caractéristiques test</h2>
          <ul className="color-product-desc">
            {Object.entries(specs)
              .filter(([_, v]) => v !== undefined)
              .map(([k, v]) => (
                <li key={k}>
                  <strong>{k}:</strong> {String(v)}
                </li>
              ))}
          </ul>
          <hr />
        </div>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Description</h2>
        <p className="color-product-desc">{description}</p>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Fiche Technique</h2>
        <p>
          <a href={ficheTechnique} target="_blank" rel="noreferrer noopener">
            Télécharger la fiche technique
          </a>
        </p>
      </section>
      <section style={{ marginTop: 32 }}>
        <RelatedProducts relatedProducts={productsRelatedTo} />
      </section>
    </>
  );
}
